/**
 * @description 配置管理器 - 集中配置管理方案
 * @author zcq
 * @date 2025-04-18
 */

import { IStrategyConfig, EEnvironment, EPlatform } from './types';

/**
 * 配置管理器 - 管理所有平台的埋点配置
 */
export class ConfigurationManager {
  private static berryUrl = '/berry/v1/rpt';

  // 平台配置映射表(平台 -> 配置)
  private static platformConfigs: Record<string, IStrategyConfig> = {
    [EPlatform.IAM]: {
        pid: "arv5i56jwu@a1bfbccf6d94680",
        publicPath: `/${EPlatform.IAM}`,
    },
    [EPlatform.ROBOT_CLOUD]: {
        pid: "arv5i56jwu@659b2e4eef0ae72",
        publicPath: "",
    },
    [EPlatform.MFA_SSO]: {
        pid: "arv5i56jwu@08e623f99f53a3f",
        publicPath: "",
    },
    [EPlatform.PARAMETER_FLOW_MANAGEMENT]: {
        pid: "arv5i56jwu@0a4edcebf684749",
        publicPath: `/${EPlatform.PARAMETER_FLOW_MANAGEMENT}`,
    },
    [EPlatform.PROPERTY_MANAGEMENT]: {
        pid: "arv5i56jwu@099c7d2d08cf6e8",
        publicPath: "",
    },
    [EPlatform.OPERATION_MAINTENANCE]: {
        pid: "arv5i56jwu@8096e91f8a7125c",
        publicPath: `/${EPlatform.OPERATION_MAINTENANCE}`,
    },
    [EPlatform.OTA_MANAGEMENT]: {
        pid: "arv5i56jwu@eb79fa16da4be6e",
        publicPath: `/${EPlatform.OTA_MANAGEMENT}`,
    },
    [EPlatform.APPLICATION_CENTER]: {
        pid: "arv5i56jwu@59c51652b81ab75",
        publicPath: '',
    },
    [EPlatform.APPS_MOBILE]: {
        pid: "arv5i56jwu@9f847e722dc488a",
        publicPath: `/${EPlatform.APPS_MOBILE}`,
    },
    [EPlatform.AUDIT_CENTER]: {
        pid: "arv5i56jwu@fed6b7945f8b3fa",
        publicPath: `/${EPlatform.AUDIT_CENTER}`,
    },
  };

  /**
   * 获取平台在特定区域的配置
   */
  public static getConfigByPlatform(platform: string, endpoint?: string): IStrategyConfig {
    const platformConfig = this.platformConfigs[platform];
    const { publicPath, ...rest } = platformConfig;
    if (!platformConfig) {
      throw new Error(`not found platform config: ${platform}`);
    }

    return {
      ...rest,
      endpoint: endpoint + this.berryUrl,
      spaMode: 'hash',
      sdkUrl: process.env.NODE_ENV === 'production' ? `${platformConfig.publicPath}/browser.js` : '/browser.js',
    };
  }

  /**
   * 注册平台配置
   */
  public static registerPlatformConfig(platform: string, config: IStrategyConfig): void {
    if (!this.platformConfigs[platform]) {
      this.platformConfigs[platform] = config;
    }
  }

  /**
   * 获取当前环境
   */
  public static getCurrentEnvironment(currentEnv?: string): EEnvironment {
    // LANE > Region > env
    const env = currentEnv || process.env.REACT_APP_LANE || process.env.REACT_APP_REGION || process.env.REACT_APP_NODE_ENV || '';

    return env as EEnvironment;
  }
}
